import React from "react";

function MMChargesToday({mmChargesToday}) {
    const options = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
    const todayFormatted = new Date().toLocaleDateString('en-US', options);

    return (
        <div className="col-lg-12">
            <div className="card custom-card" style={{paddingBottom:"10px"}}>
            <div className="card-body map-card">
                <div className="item-title">
                <h5 style={{marginBottom:10}}>MM Charges Today ({todayFormatted})</h5>
                </div>
                <table className="table mb-0 color-span">
                <thead>
                <tr>
                <th className="w-50">Category</th>
                <th></th>
                <th className="py-2 px-0" scope="col">Amount</th>
                </tr>
                </thead>
                <tbody>
                
        <tr>
          <td className="py-2 px-0">
            <span className="w-50">Parent Deposit Charges</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
            UGX. {mmChargesToday? mmChargesToday.total_cash_in.total_c:"..."}
            </span>
          </td>
        </tr>
        <tr>
          <td className="py-2 px-0">
            <span className="w-50">Vendor Withdraw Charges</span>
          </td>
          <td>:</td>
          <td className="py-2 px-0">
            <span className="">
            UGX. {mmChargesToday? mmChargesToday.total_cash_out.total_c:"..."}
            </span>
          </td>
        </tr>
    </tbody>
                </table>
            </div>
            </div>
        </div>
        
    );
}

export default MMChargesToday;
